import React, { useMemo } from 'react';

export const MoneyCellRenderer = ({ value, colDef }) => {

  const formatter = useMemo(() => {
    return new Intl.NumberFormat(undefined,
      {
        style: 'currency', 
        currency: 'USD',
        minimumFractionDigits: colDef.decimalPrecision < 2 ? colDef.decimalPrecision : 2, // Minimum of 2 decimal places unless specified to be less
        maximumFractionDigits: colDef.decimalPrecision
      })
  }, []);

  if (value == null) {
    return <span />;
  }

  return (
    <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
      {formatter.format(value)}
    </span>
  );
}